<template>
  <AppButtonOk
    @click="onSave"
    :disabled="
      form.basicSetting.isMenuIdEmpty ||
        form.basicSetting.name === '' ||
        form.deliverySetting.menuSetting.simulationLocationsAllCount > 20000
    "
    color="primary"
  >
    保存
  </AppButtonOk>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { snackbarType } from '@/vuex/modules/ui/snackbar/constants'

export default {
  name: 'SimulationFooterAddButtonSave',
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      agencyId: this.$route.params.agencyId,
    }
  },
  computed: {
    ...mapGetters('currentAdvertiser', ['currentAdvertiserId']),
    ...mapGetters('simulation', ['currentStep']),
    isLoginLP() {
      return typeof this.agencyId === 'undefined'
    },
  },
  methods: {
    ...mapActions('snackbar', {
      showSnackbar: 'SHOW_SNACKBAR',
    }),
    async onSave() {
      const validationMessages = this.form.basicSetting.validation()
      if (validationMessages.length > 0) {
        const validationMessage = validationMessages.join('\n')
        this.$confirm(`シミュレーション登録エラー`, {
          onlyOk: true,
          okText: '閉じる',
          body: validationMessage,
        })
        return
      }
      try {
        this.$emit('toggleIsRegistering')
        const { simulationPlan } = await this.form.save()
        this.showSnackbar({
          type: snackbarType.SUCCESS,
          message: 'シミュレーションを保存しました',
        })
        if (this.isLoginLP) {
          this.redirectLoginLPSimulationEdit(simulationPlan.id)
          this.$emit('toggleIsRegistering')
          return false
        }
        this.redirectAdvertiserSimulationEdit(simulationPlan.id)
        this.$emit('toggleIsRegistering')
      } catch (e) {
        this.$emit('toggleIsRegistering')
        this.showSnackbar({
          type: snackbarType.ERROR,
          message: 'シミュレーションの保存に失敗しました',
        })
      }
    },
    redirectLoginLPSimulationEdit(simulationId) {
      this.$router.push({
        name: 'LoginLpSimulationEdit',
        params: {
          simulationId,
        },
      })
    },
    redirectAdvertiserSimulationEdit(simulationId) {
      this.$router.push({
        name: 'SimulationEdit',
        params: {
          agencyId: this.agencyId,
          advertiserId: this.currentAdvertiserId,
          simulationId,
        },
      })
    },
  },
}
</script>

<style scoped></style>
